import React, { Component } from 'react';
import moment from 'moment';
import merge from 'lodash/merge';
import Form from '../form';
import Input from '../input';
import InputNumber from '../input-number';
import Select from '../select';
import DatePicker from '../date-picker';
import { DragableBodyRow } from './dragTable';

const FormItem = Form.Item;
const EditableContext = React.createContext(null);
const { TextArea } = Input;
const { Option } = Select;
const DATE_FORMAT = 'YYYY-MM-DD';
const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

const EditableRow = ({ form, index, moveRow, ...props }) => (
  <EditableContext.Provider value={form}>
    {moveRow ? (
      <DragableBodyRow index={index} moveRow={moveRow} {...props} />
    ) : (
      <tr {...props} />
    )}
  </EditableContext.Provider>
);

export const EditableFormCell = Form.create()(EditableRow);

interface ECProps {
  editable: boolean;
  record: object;
  handleSave: (record: object, type: string) => void;
  dataIndex: string;
  editType: string;
  editRules: any;
  editOptions: object[];
  optionsLabel: string;
  optionsValue: string;
  editInitValue: (value: string) => string;
  title: string;
}

interface ECState {
  editing: boolean;
}

// 根据链式key找出value
const findValueByMultiKey = (obj, prop = '') => {
  if (prop.includes('.')) {
    const props = prop.split('.');
    let value;
    props.forEach((key, index) => {
      if (index === 0) {
        value = obj[key];
      } else if (value) {
        value = value[key];
      }
    });
    return value;
  }
  return obj[prop];
};

export class EditableCell extends Component<ECProps, ECState> {
  state = {
    editing: false,
  };
  input: any;
  cell: any;
  form: any;

  dateTimePickerChange = (date, dateString, dataIndex) => {
    if (this.form) {
      this.form.setFieldsValue({
        [dataIndex]: dateString,
      });
    }
  };

  /* eslint-disable */
  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  save = () => {
    const { editType, record, handleSave } = this.props;
    this.form.validateFields((error, values) => {
      if (error) {
        return;
      }
      for (let v in values) {
        if (values[v] instanceof moment) {
          values[v] =
            editType === 'datetime'
              ? values[v].format(DATE_TIME_FORMAT)
              : values[v].format(DATE_FORMAT);
        }
      }
      this.toggleEdit();
      handleSave(merge(record, values), 'saveCell');
    });
  };

  handleOpenChange = (open) => {
    if (open) {
      this.input.focus();
    }
  };

  getInputComponent = (
    type,
    options = [],
    optionsLabel,
    optionsValue,
    dataIndex,
    initialValue?: any
  ) => {
    const opts: any = {
      ref: (node) => {
        this.input = node;
      },
      onBlur: this.save,
    };
    if (initialValue) {
      opts.defaultValue = initialValue;
    }
    if (typeof type === 'function') {
      //自定义编辑类型
      return type();
    } else {
      const children = [];
      options.forEach((item) => {
        children.push(
          <Option key={item[optionsValue]} value={item[optionsValue]}>
            {item[optionsLabel]}
          </Option>
        );
      });
      switch (type) {
        case 'number':
          return <InputNumber {...opts} />;
        case 'date':
          return <DatePicker {...opts} onOpenChange={this.handleOpenChange} />;
        case 'datetime':
          return (
            <div ref={opts.ref} onBlur={opts.onBlur}>
              <DatePicker
                defaultValue={opts.defaultValue}
                showTime
                onOpenChange={this.handleOpenChange}
                onChange={(date, dateString) =>
                  this.dateTimePickerChange(date, dateString, dataIndex)
                }
              />
            </div>
          );
        case 'select':
          return <Select {...opts}>{children}</Select>;
        case 'textarea':
          return <TextArea {...opts} onPressEnter={this.save} />;
        case 'text':
          return <Input {...opts} onPressEnter={this.save} />;
        default:
          return <Input {...opts} onPressEnter={this.save} />;
      }
    }
  };

  getInitValue = (type, value, initValue) => {
    if (typeof type === 'function' && typeof initValue === 'function') {
      return initValue(value);
    } else {
      switch (type) {
        case 'number':
          return Number(value);
        case 'date':
          return moment(value, DATE_FORMAT);
        case 'datetime':
          return moment(value, DATE_TIME_FORMAT);
        case 'select':
        case 'text':
        case 'textarea':
          return value;
        default:
          return value;
      }
    }
  };

  render() {
    const { editing } = this.state;
    const {
      editable,
      dataIndex,
      editType,
      editRules,
      editOptions,
      optionsLabel,
      optionsValue,
      editInitValue,
      title,
      record,
      ...restProps
    } = this.props;
    return (
      <td
        ref={(node) => {
          this.cell = node;
        }}
      >
        {editable && dataIndex ? (
          <EditableContext.Consumer>
            {(form) => {
              this.form = form;
              const config: any = {
                initialValue: this.getInitValue(
                  editType,
                  findValueByMultiKey(record, dataIndex),
                  editInitValue
                ),
              };
              if (editRules) {
                config.rules = editRules;
              }
              return editing ? (
                <FormItem style={{ margin: 0 }}>
                  {form.getFieldDecorator(dataIndex, {
                    ...config,
                  })(
                    this.getInputComponent(
                      editType,
                      editOptions,
                      optionsLabel,
                      optionsValue,
                      dataIndex,
                      editType === 'datetime' ? config.initialValue : null
                    )
                  )}
                </FormItem>
              ) : (
                <div
                  className="editable-cell-value-wrap"
                  style={{ paddingRight: 24 }}
                  onClick={this.toggleEdit}
                >
                  {restProps.children}
                </div>
              );
            }}
          </EditableContext.Consumer>
        ) : (
          restProps.children
        )}
      </td>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/table/editCell.tsx